import { render, staticRenderFns } from "./ModalDetalhamentoFaturaRenegociada.vue?vue&type=template&id=63359c68&scoped=true"
import script from "./ModalDetalhamentoFaturaRenegociada.vue?vue&type=script&lang=js"
export * from "./ModalDetalhamentoFaturaRenegociada.vue?vue&type=script&lang=js"
import style0 from "./ModalDetalhamentoFaturaRenegociada.vue?vue&type=style&index=0&id=63359c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63359c68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VDataTable,
  VDialog,
  VDivider,
  VIcon,
  VSpacer,
})
